// Limites dos anexos de tabela de referência da Rede Everlog (PO1-3647 e
// PO1-3650, épico PO1-3359), iguais aos do backend: pdf/xls/xlsx/csv, até 5
// arquivos de 10 MB. Validar no front evita mandar um multipart de 50 MB para
// receber um 400.

export const MAX_ARQUIVOS = 5;
export const MAX_BYTES = 10 * 1024 * 1024;
export const EXTENSOES = ["pdf", "xls", "xlsx", "csv"];
export const ACCEPT = ".pdf,.xls,.xlsx,.csv";

export function extensaoDe(nome) {
  const m = /\.([a-z0-9]+)$/i.exec(String(nome || ""));
  return m ? m[1].toLowerCase() : "";
}

// Devolve a mensagem de erro da lista, ou null quando está dentro dos limites.
export function validarAnexos(arquivos) {
  const lista = Array.isArray(arquivos) ? arquivos : [];
  if (lista.length > MAX_ARQUIVOS) return `No máximo ${MAX_ARQUIVOS} arquivos.`;
  const foraDoTipo = lista.filter((f) => EXTENSOES.indexOf(extensaoDe(f.name)) === -1);
  if (foraDoTipo.length) return `Só PDF, XLS, XLSX ou CSV: ${foraDoTipo.map((f) => f.name).join(", ")}.`;
  const grandes = lista.filter((f) => Number(f.size) > MAX_BYTES);
  if (grandes.length) return `Até 10 MB por arquivo: ${grandes.map((f) => f.name).join(", ")}.`;
  return null;
}

export function fmtTamanho(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
